import { wrap } from './callgraph'

export function piniaCallgraphPlugin(cg) {
  return ({ store }) => {
    const storeName = `store:${store.$id}`;
    for (const k of Object.keys(store)) {
      const v = store[k];
      if (typeof v === 'function') {
        store[k] = wrap(cg, `${storeName}/${k}`, v, { file: `store`, name: k });
      }
    }
  };
}

// Vuex (если Vue 2)
// function wrapVuexActions(cg, store) {
//   const wrapModule = (mod, prefix='') => {
//     if (mod.actions) {
//       for (const [k, fn] of Object.entries(mod.actions)) {
//         mod.actions[k] = async (ctx, payload) => {
//           const label = `vuex:${prefix}${k}`;
//           cg.callStart(label);
//           try {
//             return await fn(ctx, payload);
//           } finally {
//             cg.callEnd();
//           }
//         };
//       }
//     }
//     if (mod.modules) {
//       for (const [name, m] of Object.entries(mod.modules)) {
//         wrapModule(m, `${prefix}${name}/`);
//       }
//     }
//   };
//   wrapModule(store._modules.root);
// }


// 4) Свои «этапы» внутри функций/композаблов
// Точно как на бэке: оборачиваешь «крупные» шаги.
// import { wrap } from './callgraph'
// const timed = (cg, label, fn) => wrap(cg, label, fn);

// const loadData = timed(cg, 'service.loadData', async () => {
//   const raw = await fetch('/api/x').then(r => r.json());
//   await process(raw);        // если process тоже wrapped — увидишь в дереве
//   return raw;
// });




// 5) Как получить «файл и строку» (если очень нужно)
// В браузере нет фреймов как в Python, но можно дешево взять первую внешнюю строчку стека и распарсить (при наличии sourcemaps):
// function resolveCallsite() {
//   const e = new Error();
//   const s = (e.stack || '').split('\n').slice(2); // пропустить текущие 2 строки
//   // найди первую не-внутреннюю строку (не наш callgraph.js)
//   const row = s.find(l => !l.includes('callgraph.js'));
//   // row: "    at myFn (http://localhost:5173/src/comp.vue?t=..:123:45)"
//   const m = row && row.match(/(.*):(\d+):(\d+)\)?$/);
//   return m ? { file: m[1], line: Number(m[2]) } : {};
// }
// И использовать в wrap(cg, label, fn, resolveCallsite()). Это дороже по CPU, поэтому либо включай по флагу, либо только для интересующих методов.

// Если нужны файлы/строки — включи resolveCallsite() внутри wrap().


// app.config.globalProperties.$printCallTree({ max_depth:12, minTotalMs:1 });

